import { useNavigate } from "react-router-dom";

const Clickable = ({
    className,
    disabled,
    onClick = () => null,
    children,
    to,
    style,
    onLoad = () => null,
}) => {
    const navigate = useNavigate();

    return (
        <div
            className={(disabled ? "" : "clickable ") + className}
            onClick={disabled ? () => null : to ? () => navigate(to) : onClick}
            style={{ opacity: disabled ? 0.7 : 1, ...style }}
            onLoad={onLoad}
        >
            {children}
        </div>
    );
};

export default Clickable;
